<template>
    <b-row class="contacto" align-h="start">
        <b-col cols="12" class="contacto-content-titulo" lg="6">
            <p class="contacto-content" v-html="content.content"></p>
        </b-col>
        <b-col cols="12" lg="6" class="contacto-content-form-col">
            <b-row>
                <b-col cols="12" class="contacto-content-form">
                    <formulario3  :content="formulario"/>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>
<script>
    import Formulario3 from '@/components/forms/Formulario3'

    export default {
        name: 'section-contacto',
        components: {
            Formulario3
        },
        props: {
            content: Object
        },
        data: () => ({
            formulario: {
                class_color: 'formulario-black',
                text_boton: 'Enviar',
                boton_img: false
            }
        }),
        computed: {},

    }
</script>
<style lang="scss" scoped>
    .md-progress-bar {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
    }
</style>